/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import React from 'react';
import PlayIcon from '@mui/icons-material/esm/PlayArrow';
import StepForwardIcon from '@mui/icons-material/esm/SkipNext';
import StopIcon from '@mui/icons-material/esm/Stop';
import PauseIcon from '@mui/icons-material/esm/Pause';
import { connect } from 'react-redux';
import IconButton from '@mui/material/IconButton';
import CustomTooltip from '../utils/CustomTooltip';
import * as Actions from '../../actions/actions';
import { withStyles } from '@mui/styles';
import { bindActionCreators } from 'redux';
import { withAppData } from '../app/AppProvider';

function AppControlComponent(props) {
	const { machineState } = props;

	const onStart = async () => {
		props.start(props.machineId);
	};

	const onStopMachine = () => {
		if (props.machineState !== 'stopped') {
			props.stop(props.machineId);
		}
	};

	const onPauseMachine = () => {
		props.pause(props.machineId);
	};

	const onStepMachine = () => {
		if (props.machineState !== 'running') {
			props.step(props.machineId);
		}
	};

	return (
		<div
			data-tour="app-control"
			style={{
				display: 'flex',
				minHeight: '10px',
				marginTop: '2px',
			}}
		>
			<div
				style={{
					display: 'flex'
				}}
			>
				{machineState === 'running' || machineState === 'paused' ? (
					<CustomTooltip header="Tooltip.StopHeader" message="Tooltip.StopMessage">
						<div>
							<IconButton
								aria-label="Stop"
								disabled={machineState === 'stopped' || !props.appEditable}
								onClick={onStopMachine}
								size="small"
							>
								<StopIcon
									sx={{ color: (theme) => `${theme.components.MuiAppBar.styleOverrides.colorIcon.backgroundColor}, ${props.appEditable ? 1 : 0.3})`}}
								/>
							</IconButton>
						</div>
					</CustomTooltip>
				) : null}
				{machineState === 'running' ? (
					<CustomTooltip header="Tooltip.PauseHeader" message="Tooltip.PauseMessage">
						<div>
							<IconButton
								disabled={machineState === 'stopped' || machineState === 'paused' || !props.appEditable}
								onClick={onPauseMachine}
								size="small"
							>
								<PauseIcon
									sx={{ color: (theme) => `${theme.components.MuiAppBar.styleOverrides.colorIcon.backgroundColor}, ${props.appEditable ? 1 : 0.3})`}}
								/>
							</IconButton>
						</div>
					</CustomTooltip>
				) : null}
				{machineState !== 'running' ? (
					<CustomTooltip header="Tooltip.StartHeader" message="Tooltip.StartMessage">
						<div>
							<IconButton
								disabled={machineState === 'running' || !props.appEditable}
								onClick={onStart} size="small"
							>
								<PlayIcon
									sx={{ color: (theme) => `${theme.components.MuiAppBar.styleOverrides.colorIcon.backgroundColor}, ${props.appEditable ? 1 : 0.3})`}}
								/>
							</IconButton>
						</div>
					</CustomTooltip>
				) : null}
				{machineState !== 'running' ? (
					<CustomTooltip header="Tooltip.StepHeader" message="Tooltip.StepMessage">
						<div>
							<IconButton
								disabled={machineState === 'running' || !props.appEditable}
								onClick={onStepMachine} size="small"
							>
								<StepForwardIcon
									sx={{ color: (theme) => `${theme.components.MuiAppBar.styleOverrides.colorIcon.backgroundColor}, ${props.appEditable ? 1 : 0.3})`}}
								/>
							</IconButton>
						</div>
					</CustomTooltip>
				) : null}
			</div>
		</div>
	);
}
function mapDispatchToProps(dispatch) {
	return bindActionCreators({ ...Actions }, dispatch);
}

export const AppControl = withAppData(({ machine }) => ({
	machineId: machine.id,
	machineState: machine.state
}))(withStyles({}, { withTheme: true })(connect(null, mapDispatchToProps)(AppControlComponent)));
